import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { UsuarioDaoService } from 'src/app/dao/usuario-dao.service';
import { Usuario } from 'src/app/models/usuario.model';
import { PageFormBase } from '../../base/page-form-base';
import { AbstractControl, FormGroup } from '@angular/forms';
import { IIndexable } from 'src/app/models/base.model';
import { EditableFormComponent } from 'src/app/components/editable-form/editable-form.component';
import { LookupService } from 'src/app/services/lookup.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-modal-detalhe-mention',
  templateUrl: './modal-detalhe-mention.component.html',
  styleUrls: ['./modal-detalhe-mention.component.scss']
})

export class ModalDetalheMentionComponent extends PageFormBase<Usuario, UsuarioDaoService> {
  @ViewChild(EditableFormComponent, { static: false }) public editableForm?: EditableFormComponent;

  public user:any;
  public lookup: LookupService;
  public auth: AuthService;
  public entidade: any;
  
  constructor(public injector: Injector) { 
    super(injector, Usuario, UsuarioDaoService);
    this.lookup = injector.get<LookupService>(LookupService);
    this.auth = injector.get<AuthService>(AuthService);
    this.entidade = this.auth.entidade;
    this.modalWidth = 800;
  }

  ngOnInit() {
   //this.dao?.getById()
    super.ngOnInit();
    const userID = this.urlParams?.get('id') as string;
    this.loading = true;
    this.dao!.getById(userID, []).then(user => {
      this.user = user;
      console.log('USER', this.user)
      //this.loading = false;
    }).finally(() => {
      this.loading = false;
      this.form?.controls.email.setValue(this.user?.email);
      this.form?.controls.telefone.setValue(this.user?.telefone);
      this.form?.controls.funcional.setValue(this.lookup.getValue(this.lookup.USUARIO_SITUACAO_FUNCIONAL,this.user?.situacao_funcional) || "Não informado");
      this.cdRef.detectChanges();
     
    });
  }

  public validate = (control: AbstractControl, controlName: string) => {
    let result = null;
  }

  public loadData(entity: Usuario, form: FormGroup): void {
  }

  public initializeData(form: FormGroup): void {
  }

  public saveData(form: IIndexable): Promise<Usuario> {
    return new Promise<Usuario>((resolve, reject) => {
      
    });
  }
}



